import { constants } from "../constants";

export const setAlerts = alerts => ({ type: constants.SET_ALERTS, payload: alerts });

export const resetAlerts = () => ({ type: constants.RESET_ALERTS });

export const dismissAlert = idx => ({ type: constants.DISMISS_ALERT, payload: idx });
